import { useTranslation } from 'react-i18next'

import { ROUTES } from '../utils/routes'

export const useClerkConfig = () => {
  const { t } = useTranslation()

  return {
    publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
    afterSignOutUrl: ROUTES.LOGIN,
    signInUrl: ROUTES.LOGIN,
    signUpUrl: ROUTES.SIGN_UP,
    signInFallbackRedirectUrl: ROUTES.ROOT,
    signUpFallbackRedirectUrl: ROUTES.ROOT,
    localization: {
      socialButtonsBlockButton: t('clerk.socialButtonsBlockButton'),
      signIn: {
        start: {
          title: t('clerk.signIn.start.title'),
          subtitle: t('clerk.signIn.start.subtitle'),
        },
      },
      signUp: {
        start: {
          title: t('clerk.signUp.start.title'),
          subtitle: t('clerk.signUp.start.subtitle'),
        },
      },
      taskSetupMfa: {
        totpCode: {
          addAuthenticatorApp: {
            infoText__ableToScan: t(
              'clerk.taskSetupMfa.totpCode.addAuthenticatorApp.infoText__ableToScan'
            ),
          },
        },
      },
    },
  }
}
